// @vendors
import './brokerAlternativeFundsContractTab.scss'
import React from 'react';
import PropTypes from 'prop-types';
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
import { ContentBox } from 'commonsComponents/contentBox';
import { OKButton } from 'components/commons/OKButton/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';

// @components
import { BrokerCustomProductLoader } from 'components/broker/brokerCustomProductLoader/brokerCustomProductLoader';
import BrokerMyInvestmentsProducts from 'components/broker/myInvestments/brokerMyInvestmentsProducts/brokerMyInvestmentsProducts';
import BrokerMyInvestmentsContracts from 'components/broker/myInvestments/brokerMyInvestmentsContracts/brokerMyInvestmentsContracts';

// @utilites
import { PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME } from 'utilities/tagging';

const BrokerAlternativeFundsContractTab = ({
    immBrokerMyInvestments,
    immAccounts,
    immBrokerWallets,
    getStocksByContract,
    postWalletAlias,
    setOrdersAndMovementsAccessFrom,
    setOrdersAndMovementsContract,
    onOpenTraderClick,
    getContractState,
    immBrokerContractState,
    immBrokerLandingLoader,
    onInternalTransferFundsClick,
    resetSpecificProduct,
    handleShowSearchWidget,
    handleBuySearchClick,
}) => {

    const getTabContent = () => {

        const activeTab = immBrokerLandingLoader.get('activeTab');
        const isFetchingStocksByContract = immBrokerWallets.get('isFetchingProducts');
        const immStocksByContract = immBrokerWallets.get('walletList');
        const immStocksContracts = immBrokerMyInvestments.get('contracts');
        const immStocksByType = immBrokerMyInvestments.get('products');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');

        if (activeTab == 0) {
            return (
                <BrokerMyInvestmentsProducts
                    immStocksByType={immStocksByType}
                    isFetchingStocksByType={isFetchingStocksByType}
                    displayStocks={false}
                    displayWarrants={false}
                    displayETFs={false}
                    displayFunds={false}
                    displayPlans={false}
                    displayOthers={false}
                    displayAlternativeFunds={true}
                    startExpanded={true}
                    alternativeValueColumnTitle={true}
                    displayFooter={false}
                    onOpenTraderClick={onOpenTraderClick}
                    setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                    resetSpecificProduct={resetSpecificProduct}
                    pageName={PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME}
                />
            );
        }

        return (
            <BrokerMyInvestmentsContracts
                getStocksByContract={getStocksByContract}
                immAccounts={immAccounts}
                immStocksByContract={immStocksByContract}
                immStocksContracts={immStocksContracts}
                immStocksByType={immStocksByType}
                isFetchingStocksByContract={isFetchingStocksByContract}
                postWalletAlias={postWalletAlias}
                setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                onInternalTransferFundsClick={onInternalTransferFundsClick}
                onOpenTraderClick={onOpenTraderClick}
                displayStocks={false}
                displayFunds={false}
                displayPlans={false}
                displayAlternativeFunds={true}
                displayFooter={false}
                getContractState={getContractState}
                immBrokerContractState={immBrokerContractState}
            />
        );
    };

    const buildFundsTabbedContent = () => {
        const immStocksByType = immBrokerMyInvestments.get('products');
        const alternativeFunds = immStocksByType.get('alternativeFunds');
        const emptyStocks = !alternativeFunds || alternativeFunds.get('stocks').size === 0;
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const title = formatText('funds-myPositions');
        const tab = getTabContent();

        if (!isFetchingStocksByType && emptyStocks) {
            return undefined;
        }
        return (
            <ContentBox
                id={'brokerFunds'}
                title={title}
                customClassName={'tabbed-content-box broker-my-investments'}
            >
                {tab}
            </ContentBox>
        );
    };

    const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
    const fundsTabbedContent = buildFundsTabbedContent();

    let actionLinkButton = (
        <div className="broker-general-view__action-link-btn col-sm-4">
            <OKButton modifier="primary" onClick={handleBuySearchClick}>
                <FormattedText value="broker-buySellBtnText" />
            </OKButton>
        </div>
    );

    const searchButton = (
        <div className="broker-general-view__action-link-btn col-sm-8">
            <OKButton
                modifier="secondary"
                leftIcon="icon-s-buscar"
                block={true}
                onClick={() => {
                    handleShowSearchWidget()
                }}
            >
                <FormattedText value="brokerSearchWidget-brokerSearchWidget_searchAlternativeFunds" />
            </OKButton>
        </div>
    );

    let fundsTabbedContentObject;
    if (!isFetchingStocksByType) {
        if (fundsTabbedContent) {
            fundsTabbedContentObject = (
                <div className="row">
                    <div className="col-xs-12 col-md-8 broker-general-view__custom-product-loader">
                        <BrokerCustomProductLoader pageName={PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME} />
                    </div>
                    <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
                        {searchButton}
                        {actionLinkButton}
                    </div>
                    <div className="col-md-12 grid-view--fix-cell-separation">
                        {fundsTabbedContent}
                    </div>
                </div>
            );
        } 
    } else {
        fundsTabbedContentObject = <LoadingSection />;
    }

    return (
        <div className="broker-alternative-funds-contract-tabs__container">
            {fundsTabbedContentObject}
        </div>
    );
};

BrokerAlternativeFundsContractTab.propTypes = {
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    getContractState: PropTypes.func,
    immBrokerContractState: PropTypes.object,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func,
    handleShowSearchWidget: PropTypes.func,
    handleBuySearchClick: PropTypes.func,
}

export default BrokerAlternativeFundsContractTab;
